import React from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function GestorFinalizado({ tramite }) {
    return (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            <div className="d-flex justify-content-center align-items-center py-5">
                <div className="text-center">
                    <div style={{ fontSize: '4rem', color: '#28a745', marginBottom: '1rem' }}>
                        <CheckCircleIcon style={{ fontSize: '100px' }} />
                    </div>
                    <h3 className="fw-bold text-success mb-3">Trámite Finalizado</h3>
                    <p className="text-muted" style={{ fontSize: '1.1rem' }}>
                        Este trámite ha finalizado. El seguimiento ha concluido dentro de la aplicación.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default GestorFinalizado;

